import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IonButton, IonButtons, IonIcon, IonSpinner, IonToolbar } from '@ionic/angular/standalone';
import { ItemViewModel } from 'src/app/models/item.model';
import { ItemReactionComponent } from '../item-reaction/item-reaction.component';

@Component({
  selector: 'app-item-toolbar',
  templateUrl: './item-toolbar.component.html',
  styleUrls: ['./item-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ItemReactionComponent, IonToolbar, IonButtons, IonButton, IonIcon, IonSpinner]
})
export class ItemToolbarComponent {
  @Input() item: ItemViewModel;
  @Output() toggleItemDone = new EventEmitter<number>();
  @Output() shareItem = new EventEmitter<number>();
  @Output() translateItem = new EventEmitter<number>();
  @Output() showOriginalItem = new EventEmitter<number>();
  @Output() reactWith = new EventEmitter<{ itemSequenceNumber: number; reactionId: string }>();

  handleToggleItemDone(): void {
    event.stopPropagation();
    this.toggleItemDone.emit(this.item.sequenceNumber);
  }
  handleShareItem(): void {
    event.stopPropagation();
    this.shareItem.emit(this.item.sequenceNumber);
  }

  handleTranslateItem(): void {
    event.stopPropagation();
    if (!this.item.translation?.inProgress) {
      this.translateItem.emit(this.item.sequenceNumber);
    }
  }

  handleShowOriginalItem(): void {
    event.stopPropagation();
    this.showOriginalItem.emit(this.item.sequenceNumber);
  }

  handleReactWith(reactionId: string): void {
    this.reactWith.emit({ itemSequenceNumber: this.item.sequenceNumber, reactionId: reactionId });
  }
}
